<script setup lang="ts">
import { useChatUI } from 'src/composables/useChatUI';

const { t } = useI18n();
const { open } = useChatUI();

const chips = computed(() => [
  t('HYBRID_CHAT.CHIP.ABOUT_US'),
  t('HYBRID_CHAT.CHIP.PRICES'),
]);

const handleOpen = () => {
  open();
};
</script>

<template lang="pug">
.ai-chat-trigger(
  role="button"
  tabindex="0"
  @click="handleOpen"
  @keydown.enter.prevent="handleOpen"
  @keydown.space.prevent="handleOpen"
)
  .ai-chat-trigger__input
    svg.ai-chat-trigger__icon(width="18" height="18" viewBox="0 0 24 24" fill="none")
      path(d="M12 2C6.48 2 2 6.04 2 11c0 2.76 1.36 5.22 3.5 6.87V22l3.83-2.11c.86.24 1.75.36 2.67.36 5.52 0 10-4.04 10-9S17.52 2 12 2z" fill="currentColor")
    span.ai-chat-trigger__placeholder {{ t('AI_CHAT.PLACEHOLDER') }}
    svg.ai-chat-trigger__arrow(width="16" height="16" viewBox="0 0 16 16" fill="none")
      path(d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round")
  .ai-chat-trigger__chips
    button.ai-chat-trigger__chip(
      v-for="(chip, i) in chips"
      :key="i"
      @click.stop="handleOpen"
    ) {{ chip }}
</template>

<style lang="sass">
.ai-chat-trigger
  display: flex
  flex-direction: column
  align-items: center
  gap: 10px
  cursor: pointer
  max-width: 320px
  width: 100%

  &__input
    display: flex
    align-items: center
    gap: 10px
    width: 100%
    padding: 12px 16px
    background: rgba(255, 255, 255, 0.12)
    backdrop-filter: blur(16px)
    -webkit-backdrop-filter: blur(16px)
    border: 1px solid rgba(255, 255, 255, 0.25)
    border-radius: 16px
    color: rgba(0, 0, 0, 0.7)
    transition: background 0.2s, border-color 0.2s, transform 0.15s

    &:hover
      background: rgba(255, 255, 255, 0.2)
      border-color: rgba(255, 255, 255, 0.4)

    &:active
      transform: scale(0.98)

  &__icon
    color: rgba(0, 0, 0, 0.5)
    flex-shrink: 0

  &__placeholder
    flex: 1
    font-size: 14px
    text-align: left
    color: rgba(0, 0, 0, 0.6)

  &__arrow
    color: rgba(0, 0, 0, 0.4)
    flex-shrink: 0

  &__chips
    display: flex
    flex-wrap: wrap
    justify-content: center
    gap: 8px

  &__chip
    padding: 6px 12px
    background: rgba(255, 255, 255, 0.1)
    border: 1px solid rgba(255, 255, 255, 0.2)
    border-radius: 16px
    font-size: 12px
    color: rgba(0, 0, 0, 0.7)
    cursor: pointer
    transition: background 0.2s, border-color 0.2s

    &:hover
      background: rgba(255, 255, 255, 0.2)
      border-color: rgba(255, 255, 255, 0.35)
</style>
